import React from "react";
import BackgroundMap from "./BackgroundMap";

const PinOnMap = () => {
  const pins = [
    {
      id: 1,
      width: "40px",
      height: "40px",
      top: "135px",
      left: "172px",
      img: "/img/design-2.png",
    },
    {
      id: 2,
      width: "100px",
      height: "100px",
      top: "287px",
      left: "258.5px",
      img: "/img/DogWithTag.webp",
    },
    {
      id: 3,
      width: "60px",
      height: "60px",
      top: "180px",
      left: "413px",
      img: "/img/design-4.png",
    },
    {
      id: 4,
      width: "60px",
      height: "60px",
      top: "357px",
      left: "534px",
      img: "/img/design-7.png",
    },
  ];

  return (
    <div className="interactive-map-parent-container">
      <div className="interactive-map-container">
        {/* 1. რუკის ფონი */}
        <BackgroundMap />

        {/* 2. პინების ფენა */}
        {pins.map((pin, index) => (
          <div
            key={pin.id}
            className="pin-wrapper"
            style={{
              top: pin.top,
              left: pin.left,
              width: pin.width,
              height: pin.height,
              animationDelay: `${index * 0.4}s`, // თითოეული პინი 0.4 წამის დაგვიანებით დაიწყებს
            }}
          >
            <div
              className="pin-floating-part"
              style={{ animationDelay: `${index * 0.4}s` }}
            >
              <img src={pin.img} className="pin-image" alt="pin" />
            </div>
            {/* <div
            className="pin-shadow"
            style={{ animationDelay: `${index * 0.4}s` }}
          ></div> */}
          </div>
        ))}

        <div className="connected-lines line-1"></div>
        <div className="connected-lines line-2"></div>
        <div className="connected-lines line-3"></div>
      </div>

      <div className="interactive-map-text-container">
        <h2>interactiv map title</h2>
      </div>
    </div>
  );
};

export default PinOnMap;
